// Thin fetch wrapper.  Every state-changing request carries X-Atlas: 1 (CSRF guard on the server).
export class ApiError extends Error {
  constructor(status, detail) { super(detail); this.status = status; }
}

function message(detail) {
  if (Array.isArray(detail)) return detail.map(d => `${(d.loc || []).slice(1).join('.')}: ${d.msg}`).join('; ');
  return detail || 'Request failed';
}

export async function api(path, { method = 'GET', body, form } = {}) {
  const opts = { method, credentials: 'same-origin', headers: {} };
  if (method !== 'GET') opts.headers['X-Atlas'] = '1';
  if (form) opts.body = form;
  else if (body !== undefined) { opts.body = JSON.stringify(body); opts.headers['Content-Type'] = 'application/json'; }
  const r = await fetch(path, opts);
  if (r.status === 401 && !path.startsWith('/api/auth')) { window.dispatchEvent(new Event('atlas:unauthorized')); }
  if (!r.ok) {
    let d; try { d = (await r.json()).detail; } catch { d = r.statusText; }
    throw new ApiError(r.status, message(d));
  }
  const ct = r.headers.get('content-type') || '';
  return ct.includes('json') ? r.json() : r;
}

export const get = (p) => api(p);
export const post = (p, body) => api(p, { method: 'POST', body: body ?? {} });
export const patch = (p, body) => api(p, { method: 'PATCH', body });
export const del = (p) => api(p, { method: 'DELETE' });
export const upload = (p, fields) => {
  const f = new FormData();
  for (const [k, v] of Object.entries(fields)) if (v !== undefined && v !== null && v !== '') f.append(k, v);
  return api(p, { method: 'POST', form: f });
};
